import {
    UPDATE_CONSIGNMENT_ADD_DETAILS,
    UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS,
    UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_CONSIGNMENT_ADD,
} from '../actions';

const initialState = {
    updateconsignmentAdd: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    updateconsignmentAddLoading: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const updateConsignmentAddReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CONSIGNMENT_ADD_DETAILS:
            return {
                ...state,
                updateconsignmentAddLoading: true,
            };
        case UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS:
            return {
                ...state,
                updateconsignmentAdd: {
                    data: action.data,
                    statusCode: '10011',
                },
                updateconsignmentAddLoading: false,
            };
        case UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE:
            return {
                ...state,
                updateconsignmentAdd: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                updateconsignmentAddLoading: false,
            };
        case RESET_CREATE_UPDATE_CONSIGNMENT_ADD:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'updateconsignmentAddKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    updateConsignmentAddReducer
);
